let animationInitialized = false; // Flag to track initialization

document.addEventListener('DOMContentLoaded', () => {
  if (animationInitialized) {
    console.log("Animation already initialized. Skipping duplicate initialization.");
    return;
  }
  animationInitialized = true; // Set the flag to true

  console.log("Initializing GSAP Timeline...");
  
  const barTl = gsap.timeline({
    scrollTrigger: {
      trigger: ".svg-kgcontainer",
      start: "top bottom",
      end: "bottom top",
      toggleActions: "play none none reverse",
      markers: false, 
    },
  });

  barTl
    .from("h2.h2bgh", { opacity: 0, duration: 0.5 })
    .from("h3.h3bgh", { opacity: 0, duration: 0.5 }, "-=0.2")
    .from("p.pbgh", { opacity: 0, duration: 0.5 }, "-=0.2")
    .from(".top", { scale: 0, transformOrigin: "50% 50%" })
    .set(".side, .shadow", { opacity: 1 })
    .to(".barToAnimate", { y: 96, ease: "back" })
    .to(".shadow", { scaleY: 2.8, ease: "back" }, "<")
    .from(".top2", { scale: 0, duration: 0.01, transformOrigin: "50% 50%" })
    .set(".side2, .shadow2", { opacity: 1 })
    .to(".barToAnimate2", { y: 16, ease: "back" })
    .to(".shadow2", { scaleY: 3.6, ease: "back" }, "<")
    .from(".top3", { scale: 0, duration: 0.03, transformOrigin: "50% 50%" })
    .set(".side3, .shadow3", { opacity: 1 })
    .to(".barToAnimate3", { y: 42, ease: "back" })
    .to(".shadow3", { scaleY: 4, ease: "back" }, "<")
    .from(".all", { opacity: 0, scale: 0, stagger: 0.2, transformOrigin: "50% 50%" }, "<")
    .from(".inner-type", { opacity: 0, scale: 0, stagger: 0.1, transformOrigin: "50% 50%" })
    .from(".bar-buy-box", { opacity: 0, scale: 0, stagger: 0.1, transformOrigin: "50% 50%" });

  ScrollTrigger.refresh();
  console.log("ScrollTrigger refreshed!");
});
